import VueRouter from "vue-router";
// 关闭重复跳页面报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// 注册
import routerLab from '@/view/routerLab';
import userPageLab from '@/view/userPageLab';
import login from '@/view/auth/login';
import register from '@/view/auth/register';

// 普通主页
import indexHome from '@/view/index/indexHome';
import freightEstimate from '@/view/index/freightEstimate';
import mainBusiness from '@/view/index/mainBusiness';
import logisticsQuery from '@/view/index/logisticsQuery';
import freightDetail from '@/view/index/freightDetail';
import latestNews from '@/view/index/latestNews';
import newsDetail from '@/view/index/newsDetail';

// 商城模块
import shopIndex from '@/view/shop/shopIndex';
import shopMsg from '@/view/shop/shopMsg';
import shopOrder from '@/view/shop/shopOrder';
import shopAddr from '@/view/shop/shopAddr';
import shopWlMsg from '@/view/shop/shopWlMsg';
import shopCar from '@/view/shop/shopCar';
import shopSuss from '@/view/shop/shopSuss';
import shopCat from '@/view/shop/shopCat';

// 其他
import faq from '@/view/userOther/faq';
import myCollect from '@/view/userOther/myCollect';
import myCoupon from '@/view/userOther/myCoupon';
import myMarks from '@/view/userOther/myMarks';
import myNews from '@/view/userOther/myNews';
import myPPoint from '@/view/userOther/myPPoint';
import userProfile from '@/view/userOther/userProfile';
import xieyi from '@/view/userOther/xieyi';

// 主页
import userCenter from '@/view/userPage/userCenter';

// 用户物流 下单
import orderPage from '@/view/userPage/orderPage';
import orderPageAddr from '@/view/userPage/orderPageAddr';
import orderPageAddrMsg from '@/view/userPage/orderPageAddrMsg';
import orderPageAddrMsgPoin from '@/view/userPage/orderPageAddrMsgPoin';

// 用户物流 订单
import myOrderPage from '@/view/userPage/myOrderPage';
import myOrderMsg from '@/view/userPage/myOrderMsg';
import myOrderFreight from '@/view/userPage/myOrderFreight';
import myOrderPay from '@/view/userPage/myOrderPay';

// 用户包裹
import packageList from '@/view/userPage/packageList';
import packageMsg from '@/view/userPage/packageMsg';
import packageAdd from '@/view/userPage/packageAdd';
import packageAddMore from '@/view/userPage/packageAddMore';

// 代购订单
import myShopOrder from '@/view/userPage/myShopOrder';
import myShopOrderMsg from '@/view/userPage/myShopOrderMsg';
import myShopOrderReturn from '@/view/userPage/myShopOrderReturn';
import myShopPay from '@/view/userPage/myShopPay';

// 领取包裹
import selPackage from '@/view/userPage/selPackage';

// 用户地址
import myAddr from '@/view/userOther/myAddr';
import myAddrMsg from '@/view/userOther/myAddrMsg';
import myAddrMsgMore from '@/view/userOther/myAddrMsgMore';
// 路由
export default new VueRouter({
    routes:[
        {
            path:'/',
            component:routerLab,
			redirect: '/indexHome',
			children:[
				{
					path: 'login',
					component: login,
				},
				{
					path: 'register',
					component: register,
				},
				{
					path: 'indexHome',
					component: indexHome,
				},
				{
					path: 'freightEstimate',
					component: freightEstimate,
				},
				{
					path: 'mainBusiness',
					component: mainBusiness,
				},
				{
					path: 'logisticsQuery',
					component: logisticsQuery,
				},
				{
					path: 'freightDetail',
					component: freightDetail,
				},
				{
					path: 'latestNews',
					component: latestNews,
				},
				{
					path: 'newsDetail',
					component: newsDetail,
				},
				// 代购模块
				{
					path: 'shopIndex',
					component: shopIndex,
				},
				{
					path: 'shopMsg',
					component: shopMsg,
				},
				{
					path: 'shopOrder',
					component: shopOrder,
				},
				{
					path: 'shopAddr',
					component: shopAddr,
				},
				{
					path: 'shopWlMsg',
					component: shopWlMsg,
				},
				{
					path: 'shopCar',
					component: shopCar,
				},
				{
					path: 'shopSuss',
					component: shopSuss,
				},
				{
					path: 'shopCat',
					component: shopCat,
				},
			]
        },
		{
		    path:'/userPageLab',
		    component:userPageLab,
			redirect: '/userCenter',
			children:[
				{
					path: 'faq',
					component: faq,
				},
				{
					path: 'myCollect',
					component: myCollect,
				},
				{
					path: 'myCoupon',
					component: myCoupon,
				},
				{
					path: 'myMarks',
					component: myMarks,
				},
				{
					path: 'myNews',
					component: myNews,
				},
				{
					path: 'myPPoint',
					component: myPPoint,
				},
				{
					path: 'userProfile',
					component: userProfile,
				},
				{
					path: 'xieyi',
					component: xieyi,
				},
				// 其他
				{
					path: 'userCenter',
					component: userCenter,
				},
				{
					path: 'orderPage',
					component: orderPage,
				},
				{
					path: 'orderPageAddr',
					component: orderPageAddr,
				},
				{
					path: 'orderPageAddrMsg',
					component: orderPageAddrMsg,
				},
				{
					path: 'orderPageAddrMsgPoin',
					component: orderPageAddrMsgPoin,
				},
				{
					path: 'myOrderPage',
					component: myOrderPage,
				},
				{
					path: 'myOrderMsg',
					component: myOrderMsg,
				},
				{
					path: 'myOrderFreight',
					component: myOrderFreight,
				},
				{
					path: 'myOrderPay',
					component: myOrderPay,
				},
				{
					path: 'packageList',
					component: packageList,
				},			
				{
					path: 'packageMsg',
					component: packageMsg,
				},
				{
					path: 'packageAdd',
					component: packageAdd,
				},
				{
					path: 'packageAddMore',
					component: packageAddMore,
				},
				{
					path: 'selPackage',
					component: selPackage,
				},
				{
					path: 'myShopOrder',
					component: myShopOrder,
				},
				{
					path: 'myShopOrderMsg',
					component: myShopOrderMsg,
				},
				{
					path: 'myShopOrderReturn',
					component: myShopOrderReturn,
				},
				{
					path: 'myShopPay',
					component: myShopPay,
				},
				{
					path: 'myAddr',
					component: myAddr,
				},
				{
					path: 'myAddrMsg',
					component: myAddrMsg,
				},
				{
					path: 'myAddrMsgMore',
					component: myAddrMsgMore,
				}
			]
		}
    ],
	scrollBehavior(to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition;
	    }
	    // 支持平滑滚动（部分浏览器支持）
	    return { x: 0, y: 0, behavior: 'smooth' };
	  }
})
